import { createSlice } from '@reduxjs/toolkit';
import { uploadRelatedReportApi } from '../../../rtk-apis/relatedReports/uploadRelatedReport';

const initialState = {
  status: '',
  result: '',
  msg: '',
  loading: false,
};

const uploadRelatedReportSlice = createSlice({
  name: 'uploadRelatedReport',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(uploadRelatedReportApi.pending, (state, action) => {
        state.status = 'LOADING';
        state.loading = true;
      })
      .addCase(uploadRelatedReportApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
        state.msg = action?.payload?.msg;
      })
      .addCase(uploadRelatedReportApi.rejected, (state, action: any) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = (action?.payload as string) || 'Something went wrong';
      });
  },
});

export default uploadRelatedReportSlice.reducer;
export const { clearState } = uploadRelatedReportSlice.actions;
